export default String.raw`
<g id="Blog homepage/desktop/scroll">
    <rect width="1440" height="464" class="bgColor"/>
    <g>
        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="24" font-weight="500" letter-spacing="0px"><tspan x="130" y="56.7273">TRANSLATION_Prv_NewestArticles</tspan></text>
        <g id="4. Text Button" class="iconColors">
            <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="1168.41" y="53.0909">TRANSLATION_Prv_ShowAll</tspan></text>
            <g id="Arrows/chevron right">
                <use transform="translate(1290, 40)" href="#chevron-right" width="16" height="16"></use>
            </g>
        </g>
    </g>
    <g id="Banners">
        <g>
            <g id="Frame 221">
                <image x="130" y="87" clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" width="277" height="164" xlink:href="./img/previewElements/news_one.png" />
            </g>
            <g id="Frame 232">
                <g id="Frame 452">
                    <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="130" y="286.545">TRANSLATION_Prv_News_ArticleOne_Title</tspan></text>
                </g>
                <g id="Frame 453">
                    <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="130" y="323.091">TRANSLATION_Prv_News_ArticleOne_Description_LineOne </tspan><tspan x="130" y="343.091">TRANSLATION_Prv_News_ArticleOne_Description_LineTwo </tspan><tspan x="130" y="363.091">TRANSLATION_Prv_News_ArticleOne_Description_LineThree</tspan></text>
                    <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="130" y="388.364">TRANSLATION_Prv_News_ArticleOne_Tags</tspan></text>
                </g>
                <g id="Frame 451">
                    <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="130" y="424.364">PREVIEW_FIRSTPOSTDATE</tspan></text>
                    <g id="4. Text Button_2">
                        <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="299.365" y="425.091">TRANSLATION_Prv_ReadMore</tspan></text>
                        <g id="Arrows/chevron right_2">
                            <use class="iconColors" transform="translate(386, 412)" href="#chevron-right" width="16" height="16"></use>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g>
            <g id="Frame 221_2">
                <image x="431" y="87" clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" width="277" height="164" xlink:href="./img/previewElements/news_two.png" />
            </g>
            <g id="Frame 232_2">
                <g id="Frame 452_2">
                    <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="431" y="286.545">TRANSLATION_Prv_News_ArticleTwo_Title</tspan></text>
                </g>
                <g id="Frame 453_2">
                    <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="431" y="323.091">TRANSLATION_Prv_News_ArticleTwo_Description_LineOne </tspan><tspan x="431" y="343.091">TRANSLATION_Prv_News_ArticleTwo_Description_LineTwo </tspan><tspan x="431" y="363.091">TRANSLATION_Prv_News_ArticleTwo_Description_LineThree</tspan></text>
                    <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="431" y="388.364">TRANSLATION_Prv_News_ArticleTwo_Tags</tspan></text>
                </g>
                <g id="Frame 451_2">
                    <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="431" y="424.364">PREVIEW_SECONDPOSTDATE</tspan></text>
                    <g id="4. Text Button_3">
                        <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="600.365" y="425.091">TRANSLATION_Prv_ReadMore</tspan></text>
                        <g id="Arrows/chevron right_3">
                            <use class="iconColors" transform="translate(689, 412)" href="#chevron-right" width="16" height="16"></use>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g >
            <g id="Frame 221_3">
                <image x="732" y="87" clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" width="277" height="164" xlink:href="./img/previewElements/news_three.png" />
            </g>
            <g id="Frame 232_3">
                <g id="Frame 238_3">
                    <g id="Frame 452_3">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="732" y="286.545">TRANSLATION_Prv_News_ArticleThree_Title</tspan></text>
                    </g>
                    <g id="Frame 453_3">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="732" y="323.091">TRANSLATION_Prv_News_ArticleThree_Description_LineOne </tspan><tspan x="732" y="343.091">TRANSLATION_Prv_News_ArticleThree_Description_LineTwo </tspan><tspan x="732" y="363.091">TRANSLATION_Prv_News_ArticleThree_Description_LineThree</tspan></text>
                        <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="732" y="388.364">TRANSLATION_Prv_News_ArticleThree_Tags</tspan></text>
                    </g>
                    <g id="Frame 451_3">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="732" y="424.364">PREVIEW_THIRDPOSTDATE</tspan></text>
                        <g id="4. Text Button_4">
                            <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="901.365" y="425.091">TRANSLATION_Prv_ReadMore</tspan></text>
                            <g id="Arrows/chevron right_4">
                                <use class="iconColors" transform="translate(989, 412)" href="#chevron-right" width="16" height="16"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g>
            <g id="Frame 221_4">
                <image x="1033" y="87" clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" width="277" height="164" xlink:href="./img/previewElements/news_four.png" />
            </g>
            <g id="Frame 232_4">
                <g id="Frame 238_4">
                    <g id="Frame 452_4">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="1033" y="286.545">TRANSLATION_Prv_News_ArticleFour_Title</tspan></text>
                    </g>
                    <g id="Frame 453_4">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="1033" y="323.091">TRANSLATION_Prv_News_ArticleFour_Description_LineOne </tspan><tspan x="1033" y="343.091">TRANSLATION_Prv_News_ArticleFour_Description_LineTwo </tspan><tspan x="1033" y="363.091">TRANSLATION_Prv_News_ArticleFour_Description_LineThree</tspan></text>
                        <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="1033" y="388.364">TRANSLATION_Prv_News_ArticleFour_Tags</tspan></text>
                    </g>
                    <g id="Frame 451_4">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="1033" y="424.364">PREVIEW_FOURTHPOSTDATE</tspan></text>
                        <g id="4. Text Button_5">
                            <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="1202.37" y="425.091">TRANSLATION_Prv_ReadMore</tspan></text>
                            <g id="Arrows/chevron right_5">
                                <use class="iconColors" transform="translate(1290, 412)" href="#chevron-right" width="16" height="16"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g id="Arrows">
            <g id="Arrow" filter="url(#filter0_d_2123_840782)">
                <rect x="106" y="148" width="48" height="48" rx="4" class="secondaryBtnBgColor"/>
                <use class="secondaryBtnFontColor" transform="translate(122, 164)" href="#chevron-left" width="16" height="16"></use>
            </g>
            <g id="Arrow_2" filter="url(#filter1_d_2123_840782)">
                <rect x="1286" y="148" width="48" height="48" rx="4" class="secondaryBtnBgColor"/>
                <use class="secondaryBtnFontColor" transform="translate(1302, 164)" href="#chevron-right" width="16" height="16"></use>
            </g>
        </g>
    </g>
</g>
<defs>
    <filter id="filter0_d_2123_840782" x="102" y="144" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2123_840782"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2123_840782" result="shape"/>
    </filter>
    <filter id="filter1_d_2123_840782" x="1282" y="144" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2123_840782"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2123_840782" result="shape"/>
    </filter>
</defs>
`